export default {"commitHash": "", "version": ""};
